// extracted by mini-css-extract-plugin
module.exports = {"items":"CustomResultTextSection_items__BPN0Y","link":"CustomResultTextSection_link__MLW8T","linkContainer":"CustomResultTextSection_linkContainer__yGzMu"};